/* 布局 */
//前台
import Layout from "@views/layout";

const expertstationedapplymvpRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "expertstationedapplymvp",
            name: "EXPERTSTATIONEDAPPLYMVP",
            meta: {
                title: "MVP专家管理",
                sort: 1,
            },
            component: () => import("@views/business/expertstationedapplymvp/index.vue"),
            redirect: {
                name: "EXPERTSTATIONEDAPPLYMVP_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EXPERTSTATIONEDAPPLYMVP_LIST",
                    meta: {
                        title: "MVP专家管理",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/expertstationedapply/list.vue"),
                },
                {
                    path: "add",
                    name: "EXPERTSTATIONEDAPPLYMVP_ADD",
                    meta: {
                        title: "新增MVP专家",
                        parentPath: '/business/expertstationedapplymvp/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertstationedapply/form.vue"),
                },
                {
                    path: "edit",
                    name: "EXPERTSTATIONEDAPPLYMVP_EDIT",
                    meta: {
                        title: "编辑MVP专家",
                        parentPath: '/business/expertstationedapplymvp/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertstationedapply/form.vue"),
                },
                {
                    path: "info",
                    name: "EXPERTSTATIONEDAPPLYMVP_INFO",
                    meta: {
                        title: "MVP专家详情",
                        parentPath: '/business/expertstationedapplymvp/list',
                        operate: true,
                    },
                    component: () => import("@views/business/expertstationedapply/info.vue"),
                },
            ],
        },


    ],
};

export default expertstationedapplymvpRouter;
